import {Component, OnInit, Input} from '@angular/core';
import {ToolsService} from 'src/app/services/tools/tools.service';
import {AuthPageManageService} from 'src/app/services/manage/page-manage/auth-page-manage.service';
import {CssService} from "../../../../services/css-service";

@Component({
  selector: 'app-header-auth',
  templateUrl: './header-auth.component.html',
  styleUrls: ['./header-auth.component.css']
})
export class HeaderAuthComponent implements OnInit {

  // Composant auth actuel (register, login, reset pass...)
  @Input() currComp$: string | any;

  // Point de vente actuel
  currPos: any = this.tools.getStor("point_of_sale");

  // Clé du commerçant actuel
  userKey: string | any = this.tools.getStor("user_id");

  id_merchant: any = this.tools.getStor("id_merchant");

  obserButtonBack: any;
  domainUser: any;

  constructor(
    public tools: ToolsService,
    public cssService: CssService,
    public authManPag: AuthPageManageService,
  ) {
  }

  ngOnInit() {
    this.domainUser = this.tools.getStor("domainUser") ? this.tools.getStor("domainUser") : null;
  }

  /**
   * @description Redirige vers l'espace commande
   * @return {void}
   */
  goOrder() {

    // Retour à l'interface de commane
    if (this.currPos) {
      this.tools.goProductPage();
    }

    // Retour à l'interface de selection des points de vente
    else if (this.tools.getStor("id_merchant")) {
      this.tools.goPointOfSalePage();
    }
  }
}
